// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDWTIBT07zorTVXNOnlxlhq5L7D32GZpGc",
  authDomain: "leadvalaa.firebaseapp.com",
  projectId: "leadvalaa",
  storageBucket: "leadvalaa.firebasestorage.app",
  messagingSenderId: "12267509695",
  appId: "1:12267509695:web:742ccc9eb989efc5ef330a",
  measurementId: "G-82KS0WZXB1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// Function to save form data to Firestore
export const saveFreeReportForm = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, "freeReportSubmissions"), {
      ...formData,
      submittedAt: serverTimestamp(),
      status: 'new',
      source: 'website'
    });
    
    console.log("Document written with ID: ", docRef.id);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error adding document: ", error);
    return { success: false, error: error.message };
  }
};

// Function to save booking form data
export const saveBookingForm = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, "bookingSubmissions"), {
      ...formData,
      submittedAt: serverTimestamp(),
      status: 'pending',
      source: 'website'
    });
    
    console.log("Booking saved with ID: ", docRef.id);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error saving booking: ", error);
    return { success: false, error: error.message };
  }
};

export { db, analytics };
export default app;